/**
 * Store URLs — single source of truth for Thirrsty.com app store links.
 *
 * Update these once your apps are approved by Apple App Store and Google Play.
 * Until then, leave them as empty strings — the StoreBadges component will
 * render a "Coming Soon" state automatically.
 *
 * Where to find the URLs after approval:
 *   - App Store: App Store Connect → My Apps → Thirrsty → App Information → "View on App Store" link
 *     Format: https://apps.apple.com/us/app/thirrsty/id<NUMERIC_ID>
 *   - Google Play: Play Console → All apps → Thirrsty → "Store presence" → "View on Google Play"
 *     Format: https://play.google.com/store/apps/details?id=<PACKAGE_NAME>
 */

export const STORE_URLS = {
  ios: '',        // e.g. 'https://apps.apple.com/us/app/thirrsty/id1234567890'
  android: '',    // e.g. 'https://play.google.com/store/apps/details?id=com.banksclass.thirrsty'
};

export const isStoreLive = {
  ios: () => Boolean(STORE_URLS.ios && STORE_URLS.ios.startsWith('https://')),
  android: () => Boolean(STORE_URLS.android && STORE_URLS.android.startsWith('https://')),
  any: () =>
    Boolean(
      (STORE_URLS.ios && STORE_URLS.ios.startsWith('https://')) ||
      (STORE_URLS.android && STORE_URLS.android.startsWith('https://'))
    ),
};
